export const seafoam = {
  meta: {
    name: 'Seafoam'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgba(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#205d63'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #1b4f55'
    },
    divider: {
      color: '#377f86'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#377f86',
        color: 'var(--color-white)'
      }
    },

    section: {
      heading: {
        color: {
          _: '#48a9b5',
          hover: '#63c0c9',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#377f86'
            }
          },
          color: {
            _: '#48a9b5',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #377f86'
        },
        active: {
          item: {
            color: '#48a9b5'
          }
        }
      },
      item: {
        backgroundColor: {
          active: '#377f86',
          hover: 'rgba(255,255,255,.03)'
        },
        color: {
          _: '#48a9b5',
          hover: '#63c0c9',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#1b4f55'
      },
      name: {
        color: 'var(--color-white)'
      },
      company: {
        color: '#48a9b5'
      },
      trigger: {
        backgroundColor: '#2d7681',
        color: 'var(--color-white)'
      }
    }
  }
};
